import { CMSApiResponse }       from "framework/http/CMSApiClient";
import { RunContextApp }        from "framework/RCApp";
import { QA_WORKFLOW }          from "types/cms/frontendTypes";
import { CreateSurveyQuestionRequestData,
         GetMapperCatalog,
         GetQuestionBank,
         ParseQuestionMappers,
         UpdateQuestions
       }                        from "types/apis/surveyInterfaces";
import { APIData }              from "types/cms/frontendTypes";

export const SurveyQBApis = {

  createQuestion : async (rc : RunContextApp,
                           utilityDocumentId : string,
                           question : CreateSurveyQuestionRequestData) : Promise<CMSApiResponse<any>> => {

    const resp = await rc.cmsApiClient.post<any>('/survey/createQuestion', {
      utilityDocumentId : utilityDocumentId,
      data : question
    })

    return resp
  },

  getQuestionBank : async (rc : RunContextApp,
                           utilityDocumentId : string) : Promise<CMSApiResponse<GetQuestionBank.retval>> => {

    const resp = await rc.cmsApiClient.get<GetQuestionBank.retval>(
      `${GetQuestionBank.apiEndpoint}?utilityDocumentId=${utilityDocumentId}`)
    return resp
  },

  updateQuestions : async (rc : RunContextApp,
                           params : UpdateQuestions.params) : Promise<CMSApiResponse<UpdateQuestions.retval>> => {

    const resp = await rc.cmsApiClient.post<UpdateQuestions.retval>(UpdateQuestions.apiEndpoint, params)
    return resp
  },

  discardDraftQuestions : async (rc : RunContextApp, 
                                 pilotId : string, 
                                 questionDocIds : string[]) : Promise<CMSApiResponse<string[]>> => {

    const resp = await rc.cmsApiClient.post<string[]>(`/survey/discardAllDrafts`, {
      pilotId : pilotId,
      data : questionDocIds
    })
    return resp
  },

  publishQuestions : async (rc : RunContextApp, 
                            utilityDocumentId : string, 
                            questionDocIds : string[]) : Promise<CMSApiResponse<APIData<'api::survey-question.survey-question'>[]>> => {

    const resp = await rc.cmsApiClient.post<APIData<'api::survey-question.survey-question'>[]>(`/survey/publishAll`, {
      utilityDocumentId : utilityDocumentId,
      data : questionDocIds
    })
    return resp
  },

  unpublishQuestions : async (rc : RunContextApp, 
                              utilityDocumentId : string, 
                              questionDocIds : string[]) : Promise<CMSApiResponse<APIData<'api::survey-question.survey-question'>[]>> => {

    const resp = await rc.cmsApiClient.post<APIData<'api::survey-question.survey-question'>[]>(`/survey/unpublishAll`, {
      utilityDocumentId : utilityDocumentId,
      data : questionDocIds
    })
    return resp
  },

  getReviewWorkflow : async (rc : RunContextApp) : Promise<CMSApiResponse<QA_WORKFLOW>> => {
    const resp = await rc.cmsApiClient.get<QA_WORKFLOW>('/survey/getReviewWorkflow')
    return resp
  },

  // SM-20: the single grammar catalog the guided builder consumes (rules + all catalogs).
  getMapperCatalog : async (rc : RunContextApp) : Promise<CMSApiResponse<GetMapperCatalog.retval>> => {
    const resp = await rc.cmsApiClient.get<GetMapperCatalog.retval>(GetMapperCatalog.apiEndpoint)
    return resp
  },

  // SM-27: reverse-parse a question's legacy strings to prefill the guided builder.
  // Read-only on the server — nothing is persisted until the admin saves.
  parseQuestionMappers : async (rc : RunContextApp,
                                params : ParseQuestionMappers.params) : Promise<CMSApiResponse<ParseQuestionMappers.retval>> => {
    const resp = await rc.cmsApiClient.post<ParseQuestionMappers.retval>(ParseQuestionMappers.apiEndpoint, params)
    return resp
  }

}